import {
    Box,
    Center,
    Grid,
    Group,
    Paper,
    Stack,
    Text,
    Title
} from "@mantine/core";

import classes from "./MarketingComponent.module.css";
import {CallToActionComponent} from "../CallToActionComponent.tsx";
import {products} from "../product-descriptions.tsx";
import {MediumLogo} from "../../../../components/logo/MediumLogo.tsx";
import {AiOutlineArrowRight} from "react-icons/ai";
import {
    FlexiButton,
    FlexiSignInButton
} from "@flexinet/ui-components";
import {useNavigate} from "react-router-dom";
import {signInWithRedirect} from "aws-amplify/auth";

export const MarketingComponent = () => {

    const navigate = useNavigate()

    return (
        <Box className={classes.marketingComponent}>
            <Grid className={classes.heroImage} grow>
                <Grid.Col span={{
                    base: 3,
                    md: 12
                }}>
                    {products.map((product, index) => {
                        return (
                            <Paper shadow={'sm'} p={'lg'} my={"lg"} key={index}>
                                <Center>
                                    {product.smallIcon}
                                </Center>
                                <Center>
                                    <h2 className="section-title">{product.title}</h2>
                                </Center>
                                <p>{product.solution}</p>
                                <Group justify={'flex-end'}>
                                    <FlexiButton variant={'subtle'} onClick={() => navigate(product.path)}
                                                 rightSection={<AiOutlineArrowRight/>}>details</FlexiButton>
                                </Group>
                            </Paper>
                        )
                    })}

                </Grid.Col>

                <Grid.Col span={{
                    base: 4,
                    md: 12
                }}>
                    <Stack className={classes.appTitle}>
                        <MediumLogo/>
                        <Title>Organize your important communications with central email delivery and
                            storage</Title>
                        <Center className={classes.callToActionComponent}>
                            <CallToActionComponent/>
                        </Center>
                        <Center>
                            <Stack>
                                <Text>Already have an account?</Text>
                                <FlexiSignInButton onClick={
                                    () => {
                                        signInWithRedirect()
                                    }
                                }>Sign In</FlexiSignInButton>
                            </Stack>
                        </Center>
                    </Stack>
                </Grid.Col>

                <Grid.Col span={{
                    base: 5,
                    md: 12
                }}>
                </Grid.Col>

            </Grid>
        </Box>
    )

}
